import { bodyShadowSpread } from './BodyShadowStore';

export const updateBodyShadowSpread = (value) => bodyShadowSpread.update(oldValue => value);
